<template>
  <div id="app">
    <error-handler/>
    <trial-reminder v-if="isTrial"/>

    <!-- <feedback v-if="isAuthenticated"/> -->

    <upgrade-account v-if="trialExpired"/>
    
    <router-view/>
  </div>
</template>

<script>
import moment from 'moment'

// import Feedback from '@/components/Feedback.vue'
import TrialReminder from '@/components/utility/TrialReminder.vue'
import ErrorHandler from '@/components/ErrorHandler.vue'
import UpgradeAccount from '@/components/utility/UpgradeAccount.vue'

export default {
  name: 'App',
  components: {
    ErrorHandler,
    // Feedback,
    TrialReminder,
    UpgradeAccount,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    isTrial() {
      return this.$store.getters.isTrial
    },
    subscription() {
      return this.$store.getters.subscription
    },
    expiresAt() {
      return this.$store.getters.expiresAt
    },
    trialExpired() {
      if (!this.expiresAt) {
        return false
      }
      return moment().isAfter(moment(this.expiresAt))
    }
  },
  watch: {
    isAuthenticated(newValue) {
      if(newValue) {
        this.$store.dispatch('getSubscription')
        
        if(this.$intercom) {
          const user = this.$store.getters.user
          this.$intercom.boot({
            user_id: user.email,
            name: user.name,
            email: user.email
          })
          // this.$intercom.show()
        }
      }
    },
    subscription() {
      if(this.$intercom) {
        if(this.subscription) {
          let expires = moment(this.subscription.validUntil).unix()
          this.$intercom.update({
            "subscription_type": this.subscription.type,
            "subscription_expires_at": expires
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/shared.scss';
html, body {
  margin: 0;
}
#app {
  font-family: 'Ubuntu', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  color: $primaryText;
  width: 100vw;
  min-height: 100vh;
  // background-color: $background;
}
a {
  text-decoration: none;
  color: $primary;

  &:hover {
    text-decoration: underline;
  }
}
</style>
